import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getProvider = (providerId: number | undefined): Promise<IGetProvider> => {
  return axiosDefaultApi.get(`/api/Providers/GetProviderViaID/${providerId}`);
};

type QueryFnType = typeof getProvider;

type UseGetProviderOptions = {
  providerId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetProvider = ({ providerId , config }: UseGetProviderOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getProvider_${providerId}`],
    queryFn: () => getProvider(providerId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Παρόχου.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};